import { Component, ElementRef, Inject, Injector, HostListener } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from '../../../../services/AppComponentBase';
import { showScannerTrialInfoImagesModal } from '../ScannerTrialInfoImages/show-ScannerTrialInfoImages-modal';
import { ScannerNotificationComponent } from '../scanner-notification/scanner-notification.component';
import { QuotePanelsTabsList } from '../../../../enums/QuotePanelsTabs.list';




@Component({
    selector: "modal-ScannerTrialPopup",
    template: require('./ScannerTrialPopup.component.html'),
    styles: [require('./ScannerTrialPopup.component.css')]
})

export class ScannerTrialPopup extends AppComponentBase
 {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector);

        this.globaGridMode.scannerTrialLauncher.subscribe(v=>{
            
            this.activeModal.close();
            this.workspace.activeTab = QuotePanelsTabsList.SCANNER;

            if(this.workspace.mobileMode=="desktop" || this.dataService.AllowScannerMobile)
            showScannerTrialInfoImagesModal(this.modalService, this.workspace.mobileMode);
            
            this.showSmallNotification();

          });


    }

   public activateScannerTrial()
   {
       this.workspace.activateTrial();

   }

   public showSmallNotification()
   {
    let config = Object.assign(this.toastr.toastrConfig, {});
    config.timeOut = 6000;
    config.progressBar = true;
    config.closeButton = true;
    config.toastComponent = ScannerNotificationComponent;

    let params:{} = {
                        error:false,
                        text:"SCANNER SMALL GOWNO"
                    };

    this.toastr.show(JSON.stringify(params), '', config);
    
   }








   public showTrialInfoNow()
   {
       showScannerTrialInfoImagesModal(this.modalService, this.workspace.mobileMode,true);
   }








}


